import { render, staticRenderFns } from "./SoccerhowRealTimeNews.vue?vue&type=template&id=40ce32f2&scoped=true&"
import script from "./SoccerhowRealTimeNews.vue?vue&type=script&lang=js&"
export * from "./SoccerhowRealTimeNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ce32f2",
  null
  
)

export default component.exports